import { onBeforeUnmount, onMounted, reactive, ref } from 'vue'

const isLingoGameSoundMuted = ref(false)
const islandSound = ref(new Audio('/sounds/waves_320.mp3'))
const eggAngelicSound = ref(new Audio('/sounds/egg_angelic.mp3'))
const islandSoundStarted = ref(false)
const eggCrack1Sound = ref(new Audio('/sounds/egg_crack1.mp3'))
const eggCrack2Sound = ref(new Audio('/sounds/egg_crack2.mp3'))
const eggCrack3Sound = ref(new Audio('/sounds/egg_crack3.mp3'))
const eggCrack4Sound = ref(new Audio('/sounds/egg_crack4.mp3'))
const uiClaimSound = ref(new Audio('/sounds/ui-claim_320.mp3'))
const uiClickDisabled = ref(new Audio('/sounds/ui-click-disabled.mp3'))

export const useLingoGameSounds = () => {

  const audioObjects = reactive([islandSound.value, eggAngelicSound.value, eggCrack1Sound.value, eggCrack2Sound.value, eggCrack3Sound.value, eggCrack4Sound.value, uiClaimSound.value, uiClickDisabled.value])

  function playIslandSound() {
    islandSoundStarted.value = true
    islandSound.value.play()
    islandSound.value.loop = true
    islandSound.value.volume = 0.7
  }

  function playEggAngelicSound() {
    islandSound.value.volume = 0.3
    eggAngelicSound.value.volume = 0.7
    eggAngelicSound.value.loop = true
    eggAngelicSound.value.play().then(() => islandSound.value.volume = 0.7)
  }

  function playEggCrackSound(crack: number) {
    switch (crack) {
    case 0:
      eggCrack1Sound.value.play()
      break
    case 1:
      eggCrack2Sound.value.play()
      break
    case 2:
      eggCrack3Sound.value.play()
      break
    case 3:
      stopEggAngelicSound()
      eggCrack4Sound.value.play()
      break
    }
  }

  function playUiClaimSound() {
    uiClaimSound.value.volume = 0.8
    uiClaimSound.value.play()
  }

  function stopIslandSound() {
    islandSound.value.pause()
  }

  function stopEggAngelicSound() {
    eggAngelicSound.value.pause()
  }

  function toggleSound() {
    isLingoGameSoundMuted.value = !isLingoGameSoundMuted.value
    audioObjects.forEach(audio => audio.muted = isLingoGameSoundMuted.value)
  }

  function muteSounds() {
    isLingoGameSoundMuted.value = true
    audioObjects.forEach(audio => audio.muted = true)
  }

  function unmuteSounds() {
    isLingoGameSoundMuted.value = false
    audioObjects.forEach(audio => audio.muted = false)
  }

  function stopAllSounds() {
    stopIslandSound()
    stopEggAngelicSound()
  }

  function playUiClickDisabledSound() {
    uiClickDisabled.value.play()
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      muteSounds()
    } else {
      setTimeout(() => unmuteSounds(), 300)
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  return {
    playIslandSound,
    isLingoGameSoundMuted,
    toggleSound,
    islandSoundStarted,
    playEggAngelicSound,
    stopAllSounds,
    playEggCrackSound,
    playUiClaimSound,
    muteSounds,
    unmuteSounds,
    playUiClickDisabledSound,
  }
}